<template>
    <body class="bg-softGray text-primary font-sans min-h-screen flex flex-col">
<main class="flex-grow flex items-center justify-center px-4 py-16">
  <div class="bg-white rounded-2xl shadow-lg max-w-xl w-full p-10 text-center animate-fadeIn">
    <div class="text-accent text-5xl mb-4">
      <i class="fas fa-circle-check"></i>
    </div>
    <h2 class="text-3xl font-semibold mb-2">Thank You!</h2>
    <p class="text-lg text-gray-700">
      Thank you for completing the 2025 Fee for Services Network Attorney Agreement. You may close this page now.
    </p>
    <button
          @click="redirectToLogin"
          class="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          Close
        </button>
  </div>
</main>
<footer class="bg-white border-t border-gray-200 py-4">
  <div class="container mx-auto text-center text-sm text-gray-500">
    &copy; 2021 U.S. Legal Services. All rights reserved.
  </div>
</footer>

</body>
  </template>
  
  <script>

  export default {
    name: 'ThankYou',
    methods: {
    redirectToLogin() {
      this.$router.push({ name: 'Login' });
    }
  }
  };
  </script>
  
  <style scoped>
  </style>
  